module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAbCAMAAABVyG9ZAAAAXVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9RKvvlAAAAHnRSTlMA8CJKxHmH6LyugDyjcFsuFvXkzmRT4dazkUMonzWl3EZlAAAAwUlEQVQoz3WR6RKDIBCDOYpS8apnre2+/2N2cRiDlOZXnM/NBhBtaUVQPy5aRCKiW7AbexehO5hm+/jDZmLFmRas8kxF7Ak2sZWvNBOMYjaCFcj8mWt9T53fZ4jVJZkWPcs9ybTIJJecr0KXRUSSRGuwb2aHwa91uM2BW4IYv7w/bEes5iQ1fw39+QI0s0FhqUDaa5pCmrmkyShNX2ZkdqYAcRLdQDLdGpDdkyo38/FpkzgFIupjD7TJVQXrhtJE5AtaFRgeefbMiAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/baijt.png
// module id = Az7z
// module chunks = 0